import React from 'react';
import { Box } from '@mui/material';
import VeraPromptContextGuide from '../VeraPromptContextGuide';
import { getVeraPromptContextGuide } from '../veraPromptContextGuides';
import { StyledButton } from '../../styles/StyledButtons';
import StyledFieldDescription from '../../styles/StyledFieldDescription';
import { StyledLabel } from '../../styles/styles';
import { MONOSPACE_TEXTAREA_STYLE, PRODUCTION_REFERENCE_SX } from './adminAssistPromptStyles';

interface AdminAssistIntentPromptTabProps {
  intentText: string;
  intentProductionText: string;
  onIntentChange: (value: string) => void;
  onResetToProduction: () => void;
}

export default function AdminAssistIntentPromptTab({
  intentText,
  intentProductionText,
  onIntentChange,
  onResetToProduction,
}: AdminAssistIntentPromptTabProps) {
  return (
    <>
      <VeraPromptContextGuide markdown={getVeraPromptContextGuide('admin_intent')} />
      <StyledFieldDescription stacked sx={{ mb: 2 }}>
        Classifies the investor&apos;s latest message as <code>ADVICE</code>, <code>LOCATION</code>,
        or <code>ALLOWED</code>. <code>LOCATION</code> loads verified Maps context.{' '}
        <code>ALLOWED</code> and <code>LOCATION</code> (not <code>ADVICE</code>) may use Google
        Search per the Google Search prompt tab.
      </StyledFieldDescription>

      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
          <StyledLabel stacked>Intent Classifier Prompt</StyledLabel>
          <StyledButton
            size="small"
            variant="outlined"
            onClick={onResetToProduction}
            disabled={intentText.trim() === intentProductionText.trim()}
          >
            Reset to coded version
          </StyledButton>
        </Box>
        <textarea
          value={intentText}
          onChange={(event) => onIntentChange(event.target.value)}
          rows={12}
          style={{ ...MONOSPACE_TEXTAREA_STYLE, marginTop: 8 }}
        />
      </Box>

      {intentProductionText && (
        <Box sx={{ mb: 3 }}>
          <StyledLabel stacked>Current coded version (read-only reference)</StyledLabel>
          <Box component="pre" sx={PRODUCTION_REFERENCE_SX}>
            {intentProductionText}
          </Box>
        </Box>
      )}
    </>
  );
}
